// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Workspace credential vault UI (Apps -> API credentials). Mirrors the Apps
   surface look: brand purple #5616ea, DM Sans, rounded cards. */
.cred-mgr {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cred-mgr-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.cred-mgr-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f1147;
}

.cred-mgr-sub {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #6b6485;
  max-width: 46ch;
}

.cred-add-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #5616ea;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.cred-add-btn:hover { background: #4a12c9; }

.cred-loading,
.cred-empty {
  font-size: 0.88rem;
  color: #6b6485;
  padding: 12px 0;
}
.cred-loading { display: flex; align-items: center; gap: 8px; }

.cred-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cred-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e6e0f5;
  border-radius: 10px;
  background: #fff;
}

.cred-row-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #f1ecfe;
  color: #5616ea;
}

.cred-row-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cred-row-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #1f1147;
  word-break: break-all;
}

.cred-row-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.78rem;
  color: #6b6485;
}

.cred-type-chip {
  background: #f1ecfe;
  color: #5616ea;
  border-radius: 999px;
  padding: 2px 8px;
  font-weight: 600;
}

.cred-hint {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  color: #8a82a6;
}

.cred-row-actions {
  flex-shrink: 0;
  display: flex;
  gap: 6px;
}

.cred-icon-btn {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: 1px solid #e6e0f5;
  border-radius: 8px;
  background: #fff;
  color: #6b6485;
  cursor: pointer;
  transition: all 0.15s ease;
}
.cred-icon-btn:hover { border-color: #c4b5fd; color: #5616ea; }
.cred-icon-btn.cred-danger:hover { border-color: #f3b4b4; color: #d33; }

.cred-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 6px;
}

.cred-error {
  margin: 0;
  font-size: 0.82rem;
  color: #d33;
}
`, "",{"version":3,"sources":["webpack://./src/components/CredentialsManager.css"],"names":[],"mappings":"AAAA;gEACgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAE9D;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;AACA,uBAAuB,qBAAqB,EAAE,cAAc,EAAE;AAC9D,mCAAmC,qBAAqB,EAAE,WAAW,EAAE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["/* Workspace credential vault UI (Apps -> API credentials). Mirrors the Apps\r\n   surface look: brand purple #5616ea, DM Sans, rounded cards. */\r\n.cred-mgr {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.cred-mgr-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.cred-mgr-title {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: #1f1147;\r\n}\r\n\r\n.cred-mgr-sub {\r\n  margin: 4px 0 0;\r\n  font-size: 0.85rem;\r\n  color: #6b6485;\r\n  max-width: 46ch;\r\n}\r\n\r\n.cred-add-btn {\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 8px 14px;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n.cred-add-btn:hover { background: #4a12c9; }\r\n\r\n.cred-loading,\r\n.cred-empty {\r\n  font-size: 0.88rem;\r\n  color: #6b6485;\r\n  padding: 12px 0;\r\n}\r\n.cred-loading { display: flex; align-items: center; gap: 8px; }\r\n\r\n.cred-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.cred-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 14px;\r\n  border: 1px solid #e6e0f5;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n}\r\n\r\n.cred-row-icon {\r\n  flex-shrink: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: grid;\r\n  place-items: center;\r\n  border-radius: 8px;\r\n  background: #f1ecfe;\r\n  color: #5616ea;\r\n}\r\n\r\n.cred-row-main {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.cred-row-name {\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  color: #1f1147;\r\n  word-break: break-all;\r\n}\r\n\r\n.cred-row-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  font-size: 0.78rem;\r\n  color: #6b6485;\r\n}\r\n\r\n.cred-type-chip {\r\n  background: #f1ecfe;\r\n  color: #5616ea;\r\n  border-radius: 999px;\r\n  padding: 2px 8px;\r\n  font-weight: 600;\r\n}\r\n\r\n.cred-hint {\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\r\n  color: #8a82a6;\r\n}\r\n\r\n.cred-row-actions {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.cred-icon-btn {\r\n  width: 30px;\r\n  height: 30px;\r\n  display: grid;\r\n  place-items: center;\r\n  border: 1px solid #e6e0f5;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #6b6485;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n.cred-icon-btn:hover { border-color: #c4b5fd; color: #5616ea; }\r\n.cred-icon-btn.cred-danger:hover { border-color: #f3b4b4; color: #d33; }\r\n\r\n.cred-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  padding-top: 6px;\r\n}\r\n\r\n.cred-error {\r\n  margin: 0;\r\n  font-size: 0.82rem;\r\n  color: #d33;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
